module.exports = __webpack_public_path__ + "static/media/corporate-services-img30.70a30972.jpg";